<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopVisit.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopVisitManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="shopVisitManageInfo.conditions.visitId"
                :placeholder="$t('shopVisit.visitIdPlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="shopVisitManageInfo.conditions.visitUserName"
                :placeholder="$t('shopVisit.visitUserPlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="shopVisitManageInfo.conditions.visitIp"
                :placeholder="$t('shopVisit.visitIpPlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryOrdersMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button @click="_resetOrdersMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopVisit.shopVisit') }}</div>
      </div>
      <div class="">
        <el-table :data="shopVisitManageInfo.visits" border style="width: 100%">
          <el-table-column prop="visitId" :label="$t('shopVisit.visitId')" align="center" />
          <el-table-column prop="visitUserName" :label="$t('shopVisit.visitUser')" align="center" />
          <el-table-column prop="visitIp" :label="$t('shopVisit.visitIp')" align="center" />
          <el-table-column prop="createTime" :label="$t('shopVisit.visitTime')" align="center" />
          <el-table-column prop="remark" :label="$t('shopVisit.remark')" align="center" />
        </el-table>

        <el-pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
          :total="shopVisitManageInfo.total" layout="total, prev, pager, next, jumper" style="margin-top: 20px;" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryShopVisit } from '@/api/goods/shopVisitApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopVisitManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      shopVisitManageInfo: {
        visits: [],
        total: 0,
        records: 1,
        conditions: {
          visitUserName: '',
          visitIp: '',
          visitId: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listShopVisits(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    async _listShopVisits(_page, _rows) {
      this.shopVisitManageInfo.conditions.page = _page
      this.shopVisitManageInfo.conditions.row = _rows
      this.shopVisitManageInfo.conditions.shopId = getShopId()

      const params = {
        ...this.shopVisitManageInfo.conditions,
        visitId: this.shopVisitManageInfo.conditions.visitId.trim(),
        visitUserName: this.shopVisitManageInfo.conditions.visitUserName.trim(),
        visitIp: this.shopVisitManageInfo.conditions.visitIp.trim()
      }

      try {
        const res = await queryShopVisit(params)
        this.shopVisitManageInfo.total = res.total
        this.shopVisitManageInfo.records = res.records
        this.shopVisitManageInfo.visits = res.data
        this.currentPage = _page
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryOrdersMethod() {
      this._listShopVisits(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetOrdersMethod() {
      this.shopVisitManageInfo.conditions.visitId = ""
      this.shopVisitManageInfo.conditions.visitUserName = ""
      this.shopVisitManageInfo.conditions.visitIp = ""
      this._listShopVisits(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handlePageChange(val) {
      this._listShopVisits(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>